import PropTypes from 'prop-types';
import PageContainer from './pageContainer';
import NavigationBar from './navigationBar';

const Layout = ({ Design, Theme }) => (
  <>
    <PageContainer Page={Design} ThemeName={Theme} />
    <NavigationBar />
  </>
);

Layout.propTypes = {
  Design: PropTypes.func.isRequired,
  Theme: PropTypes.string,
};

Layout.defaultProps = {
  Theme: 'dark',
};

export default Layout;
